import { useState } from "react";
import AuthShell from "./AuthShell";
import AuthField from "./AuthField";
import Button from "../../ui/Button";
import { portalEyebrow } from "./portalAuthCopy";
import {
  formatLoginIdentifier,
  isPhoneLikeLoginInput,
  normalizeLoginIdentifier,
  normalizePhoneRu,
} from "../../../utils/phoneMask";
import a from "./auth.module.css";

export default function AuthLoginFlow({
  heroBadge,
  backTo,
  backLabel,
  title = "Вход",
  subtitle,
  perks: _perks,
  portalId = "patient",
  emailPlaceholder = "+7 … или email",
  loading,
  error,
  onSubmit,
  footer,
  segment,
  navExtra: _navExtra,
}) {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");

  const submit = (e) => {
    e.preventDefault();
    onSubmit({ login: normalizeLoginIdentifier(login), password });
  };

  const handleLoginChange = (e) => {
    const v = e.target.value;
    if (v.includes("@")) {
      setLogin(v);
      return;
    }
    if (!isPhoneLikeLoginInput(v)) {
      setLogin(v);
      return;
    }
    if (!v.replace(/\D/g, "")) {
      setLogin("");
      return;
    }
    setLogin(normalizePhoneRu(v));
  };

  const loginDisplay =
    login.includes("@") || !isPhoneLikeLoginInput(login)
      ? login
      : formatLoginIdentifier(login);

  const clubName = heroBadge || null;
  const hint =
    subtitle ||
    (clubName
      ? `Кабинет клуба «${clubName}»`
      : portalEyebrow(null, portalId));

  return (
    <AuthShell
      modern
      backTo={backTo}
      backLabel={backLabel}
      showSwitcher={false}
      showBrand
      cardTitle={title}
      hint={hint}
      segment={segment}
      footer={footer}
      clubTag={clubName}
    >
      {error ? <div className={a.errorBox}>{error}</div> : null}

      <form onSubmit={submit}>
        <AuthField
          label="Телефон или email"
          type="text"
          name="login"
          autoComplete="username"
          value={loginDisplay}
          onChange={handleLoginChange}
          placeholder={emailPlaceholder}
          required
        />
        <AuthField
          label="Пароль"
          type="password"
          name="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          required
        />
        <div className={a.actions}>
          <Button type="submit" block size="lg" disabled={loading}>
            {loading ? "Вход…" : "Войти"}
          </Button>
        </div>
      </form>
    </AuthShell>
  );
}
